import React from "react";
import logo from "../assets/logo-rot-weis.png"
import {navLinks} from "../constants";
import {Link} from "react-router-dom"

const Navbar = () => {
    return(
        <div className="w-full flex justify-between absolute top-0">
            <Link to="/">
                <img src={logo} className="w-48 p-5" />
            </Link>
            <ul className="flex items-center pr-5 text-white text-xl font-Visby">
                {navLinks.map((nav, index) => (
                    <li>
                        <Link to={`${nav.id}`} className="px-3">
                            {nav.title}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default Navbar